<template>
    <div>
        <b-card no-body>
            <b-alert variant="primary" show style="display: inline-block; vertical-align: top;">
                <div style="display: inline-block; vertical-align: top;">
                    <div>DATES</div>
                    <date-picker
                    v-model="date_range"
                    format="MM-DD-YYYY"
                    valueType="format"
                    style="width: 220px; font-size: 15px; display: block;"
                    placeholder="DATE OR DATE RANGE"
                    range
                    ></date-picker>
                </div>

                <!-- <div style="display: inline-block; vertical-align: top;">
                    <div>INVOICE / CUSTOMER / SALESPERSON</div>
                    <b-input size="sm" v-model="search_txt"></b-input>
                </div> -->

                <div style="display: inline-block; vertical-align: top;">
                     <div>&nbsp;</div>
                    <b-button variant="success" style="display: inline-block; padding: 3px;" @click="fetch_init">SEARCH</b-button>
                </div>


                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'locationadmin') && (items.length > 0) ">
                    <div>SALESPERSON</div>
                    <b-form-select :options="users" v-model="picked_user" style="width: 200px;"></b-form-select>
                </div>

                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin' || packet.userDetails.userrole == 'locationadmin') && (items.length > 0) ">
                    <div>ISSUING AGENT</div>
                    <b-form-select :options="users" v-model="picked_created_by" style="width: 200px;"></b-form-select>
                </div>

                <div style="display: inline-block;" v-if="(packet.userDetails.userrole == 'admin') && (items.length > 0) ">
                    <div>SALE LOCATION</div>
                    <b-form-select :options="packet.locations" v-model="picked_location" style="width: 200px;"></b-form-select>
                </div>

                <!-- <div style="display: inline-block;" v-if="(items.length > 0) ">
                    <div>SALE TYPE</div>
                    <b-form-select :options="sale_types" v-model="sale_type" style="width: 200px;"></b-form-select>
                </div>    -->
            </b-alert>

            <b-card-text style="padding-left: 15px; gap: 5px;" class="d-flex flex-wrap">
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='today'" @click="set_dates('today')">TODAY</b-button>
                <b-button size="sm" variant="outline-dark"  :pressed="picked_date_range=='yesterday'" @click="set_dates('yesterday')">YESTERDAY</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='this_week'" @click="set_dates('this_week')">THIS WEEK</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='last_week'" @click="set_dates('last_week')">LAST WEEK</b-button>
                <b-button size="sm"  variant="outline-dark"  :pressed="picked_date_range=='this_month'" @click="set_dates('this_month')">THIS MONTH</b-button>
                <b-button size="sm" variant="outline-dark"  :pressed="picked_date_range=='last_month'" @click="set_dates('last_month')">LAST MONTH</b-button>
            </b-card-text>

            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" style="margin-top: 10px; overflow: scroll;" class="mx-2 mx-md-0 mb-2">
                    <table class="text-monospace" style="width: 100%;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr" style="min-width: 100px; width: 170px;" @click="sortby('created_ts')">
                                    DATE
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px;" @click="sortby('locsub')">
                                    INVOICE LOCATION
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px;" @click="sortby('invoice_id')">
                                    INVOICE #
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px;" @click="sortby('username')">
                                    SALE BY
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px;" @click="sortby('created_by')">
                                    REFUND ISSUED BY
                                </td>
                                <td class="ipt_tdhr" style="min-width: 100px;" @click="sortby('total')">
                                    AMOUNT
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr style="background: lightyellow;">
                                <td class="ipt_tdhr header">

                                </td>
                                <td class="ipt_tdhr header">

                                </td>
                                <td class="ipt_tdhr header">

                                </td>
                                <td class="ipt_tdhr header">

                                </td>
                                <td class="ipt_tdhr header">

                                </td>
                                <td class="ipt_tdhr header">
                                    <b>{{ total('total_refunds').toFixed(2) }}</b>
                                </td>


                            </tr>
                        </tbody>

                        <tbody>
                            <tr v-for="item,idx in filter" v-bind:key="idx">
                                <td class="ipt_tdhr non-header">
                                    {{item.created_ts}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{packet.locsubsdict[item.locsub]}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <a
                                        href="#"
                                        @click.prevent="goToSale(item.invoice_id)"
                                        class="invoice-link"
                                        :title="'View sale details for ' + item.invoice_id"
                                    >
                                        {{item.invoice_id}}
                                    </a>
                                </td>
                                <td class="ipt_tdhr  non-header" @click="sortby('username')">
                                   {{item.username}}
                                </td>

                                <td class="ipt_tdhr  non-header" @click="sortby('created_by')">
                                   {{item.created_by}}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.total_refunds }}
                                </td>


                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert show variant="warning">NO REFUNDS</b-alert>
                </div>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    import moment from 'moment';
    import global_vars from '@/utilities/global_vars';
    import Backer from '@/components/globals/Backer';
    import Requestor from '@/utilities/Requestor';

    export default {
        name: "ListRefunds",
        components: {Backer, DatePicker},
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                date_range: [],
                picked_date_range: null,
                sort_asc: false,
                users: [],
                usersdict: {},
                picked_user: null,
                picked_location: null,
                picked_created_by: null,
            }
        },
        computed: {
            filter: function(){
                let that = this;

                return this.items.filter(function(d){
                    //console.log(d.data.final_eta, that.date_range)
                    return (
                        ((that.picked_user) ? d.username == that.picked_user : true )
                        &&
                        ((that.picked_location) ? d.location_id == that.picked_location : true )
                        &&
                        ((that.picked_created_by) ? d.created_by == that.picked_created_by : true )

                    )
                })
            }
        },
        methods: {
              goToSale: function(invoiceId) {
        // // Construct the URL based on your pattern
        // const saleUrl = `https://inventory.myfurnituremecca.com/#/sales/viewsale/${invoiceId}/`;

        // // Navigate to the sales page
        // window.location.href = saleUrl;
          this.$router.push("/sales/viewsale/" + invoiceId + "/");

        // Alternative: If you're using Vue Router in your app, you might use:
        // this.$router.push(`/sales/viewsale/${invoiceId}/`);
    },
            allowed: function(item) {
                let status = true;

                if (this.picked_user == null && this.picked_location == null){
                    status = true
                }

                if (this.picked_user != null && this.picked_location == null){
                    if (item.username == this.picked_user){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user == null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        status = true
                    }
                    else {
                        status = false
                    }
                }

                if (this.picked_user != null && this.picked_location != null){
                    if (item.location_id == this.picked_location){
                        if (item.username == this.picked_user){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false
                    }
                }
                return status
            },
            total: function(key){
                let that = this;
                let out = this.filter.filter(function(d){return that.allowed(d) == true});
                let total_val = 0.0;
                for (var i=0; i<out.length; i++){
                    total_val += ( parseFloat(out[i][key]) || 0.0);
                }
                return total_val
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");

                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }



                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;

                    this.fetch_init()
                }
            },
            fetch_init: function(){
                let dates = this.date_range;
                let that = this;
                let data = {dates: dates, username: this.packet.userDetails.username, location_id: (this.packet.userDetails.properties.location_id || null)}
                let path = "/api/sales/list_refunds/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        //that.process_data_for_plot();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_users_list: function(){
                let data = {userrole: this.packet.userDetails.userrole, user_id: this.packet.userDetails.id};
                // if (location_id){
                //     data.location_id = location_id;
                // }
                let that = this;
                let path = "/api/user/get_my_users_list/"
                let s = function(response) {
                    if (response.data.result){
                        that.users = response.data.result;

                        for (var i=0; i<that.users.length; i++){
                            that.usersdict[that.users[i].value] = true;
                        }

                        that.users.splice(0, 0, {value: null, text: "ALL"});
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    //that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    //that.items_being_loaded = false
                }
                //this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            },
            process_data_for_plot: function(){
                let that = this;
                this.report_chart_1_data = {};
                this.report_chart_1_config = {};
                let items = this.items.filter(function(d){return that.allowed(d)}).map(function(d){d.date = d.ts.split(" ")[0]; return d;});
                let outdict = {};
                for (var i=0; i<items.length; i++){
                    let it = items[i];
                    let date = it.date;
                    if (!outdict[date]){
                        outdict[date] = (it.total_dollar_amount || 0.0);
                    }
                    else {
                        outdict[date] += (it.total_dollar_amount || 0.0);
                    }
                }
                let labels = Object.keys(outdict);
                let vals = Object.values(outdict);
                this.report_chart_1_data = {
                    labels: labels,
                    datasets: [{data: vals, label: "TOTAL SALE", fill: true, tension: 0.1, borderColor: "#dc3545"}],
                };
                this.report_chart_1_config = {type: 'line'};
            },
        },

        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);

            if (this.packet.userDetails.userrole == "admin" || this.packet.userDetails.userrole == "locationadmin"){
                this.fetch_users_list();
            }
        }
    }
</script>

<style scoped>
      .invoice-link {
        color: #007bff;
        text-decoration: underline;
        cursor: pointer;
    }

    .invoice-link:hover {
        color: #0056b3;
        text-decoration: none;
    }

    .header {
        font-size: 13px;
    }

    .non-header {
        font-weight: normal;
        font-size: 13px;
        background: beige;
        font-family: roboto;
    }

    .srr {
        font-size: 11px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sales/ListRefunds.vue